import __request__ from "routing/request";
export function list(paginationparameters, requestOptions) {
  return __request__("GET", "/system/authentication/services/backends", paginationparameters, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(JSONbody, requestOptions) {
  return __request__("POST", "/system/authentication/services/backends", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getActiveType(requestOptions) {
  return __request__("GET", "/system/authentication/services/backends/active-backend/type", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(backendId, requestOptions) {
  return __request__("GET", `/system/authentication/services/backends/${backendId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(backendId, JSONbody, requestOptions) {
  return __request__("PUT", `/system/authentication/services/backends/${backendId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(backendId, requestOptions) {
  return __request__("DELETE", `/system/authentication/services/backends/${backendId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getUsers(sort = "full_name", backendId, page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", `/system/authentication/services/backends/${backendId}/users`, null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
